import { compose, hoistStatics, lifecycle, withState, withProps } from 'recompose';
import { translate } from 'react-i18next';
import ChatBox from './ChatBox';
import WithLoading from '../../../../../components/WithLoading';

class RefsStore {
  store(name, value) {
    this[name] = value;
  }
}

const enhance = compose(
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withProps({ refs: new RefsStore() }),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading } = this.props;
      setIsLoading(false);
    },
    getSnapshotBeforeUpdate(prevProps, prevState) {
      if (this.props.messages &&
        (!prevProps.messages ||
          Object.keys(prevProps.messages).length < Object.keys(this.props.messages).length)) {
        let direction = 0; //0 - down, 1 - up
        let snapshot = { direction: 0, value: 0 };

        if (prevProps.messages && this.props.messages) {
          if (Object.keys(prevProps.messages)[0] === Object.keys(this.props.messages)[0]) {
            direction = 1;
          }
        }

        const list = this.props.refs.listRef;

        if (list) {
          if (direction) { //down
            snapshot = { direction, value: 0 };
          } else {
            snapshot = { direction, value: list.scrollHeight - list.scrollTop };
          }
          return snapshot;
        }
      }
      return null;
    },
    componentDidUpdate(prevProps, prevState, snapshot) {
      if (snapshot !== null) {
        const list = this.props.refs.listRef;
        if (snapshot.direction) {
          list.scrollTop = snapshot.value;
        } else {
          list.scrollTop = list.scrollHeight - snapshot.value;
        }
      }
    },
  }),
);

export default hoistStatics(enhance)(WithLoading(ChatBox));



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/chatBox/index.js